import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SettingsComponent } from './components/settings/settings.component'

import { FormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { CardModule } from 'primeng/card'
import { ContextMenuModule } from 'primeng/contextmenu'
import { DialogModule } from 'primeng/dialog'
import { DropdownModule } from 'primeng/dropdown'
import { DynamicDialogModule } from 'primeng/dynamicdialog'
import { FileUploadModule } from 'primeng/fileupload'
import { GalleriaModule } from 'primeng/galleria'
import { InputSwitchModule } from 'primeng/inputswitch'
import { ListboxModule } from 'primeng/listbox'
import { MultiSelectModule } from 'primeng/multiselect'
import { PanelModule } from 'primeng/panel'
import { PanelMenuModule } from 'primeng/panelmenu'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { TableModule } from 'primeng/table'
import { TooltipModule } from 'primeng/tooltip'
import { MessagesModule } from 'primeng/messages'
import { MessageModule } from 'primeng/message'
import { TabViewModule } from 'primeng/tabview'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { CheckboxModule } from 'primeng/checkbox'
import { CalendarModule } from 'primeng/calendar'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { InputTextModule } from 'primeng/inputtext'
import { ChartModule } from 'primeng/chart'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { TreeTableModule } from 'primeng/treetable'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { DirectivesModule } from '../../modules/directives/directives.module'

@NgModule({
  declarations: [SettingsComponent],
  imports: [
    CommonModule,
    FormsModule,
    InputSwitchModule,
    DropdownModule,
    CardModule,
    TableModule,
    TooltipModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    ButtonModule,
    GalleriaModule,
    PanelModule,
    PanelMenuModule,
    FileUploadModule,
    ListboxModule,
    MessagesModule,
    MessageModule,
    TabViewModule,
    ScrollPanelModule,
    DynamicDialogModule,
    CheckboxModule,
    CalendarModule,
    OverlayPanelModule,
    InputTextModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    ChartModule,
    InputTextareaModule,
    TreeTableModule,
    DirectivesModule
  ]
})
export class SettingsModule {}
